module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isInput) ? _c('div', {
    staticClass: "fullPage",
    on: {
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "main"
  }, [_c('img', {
    staticClass: "back",
    attrs: {
      "src": require("../../assets/img/team/back.png")
    },
    on: {
      "click": function($event) {
        _vm.back()
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "tit"
  }, [_vm._v("兑换礼包中的奖品")]), _vm._v(" "), _c('p', {
    staticClass: "hint"
  }, [_vm._v("集齐10Q点可以兑换1Q币，集齐20Q点可以兑换2Q币，依次类推。未满10的倍数不予兑换")]), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_vm._v("请输入你的QQ号码，小悠会在活动结束后，直接将Q币充值到填写的QQ账户中。")]), _vm._v(" "), _c('div', {
    staticClass: "submit"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.number),
      expression: "number"
    }],
    class: _vm.redClass,
    attrs: {
      "placeholder": "请输入QQ号码"
    },
    domProps: {
      "value": (_vm.number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.number = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("提交")]), _vm._v(" "), (_vm.noError) ? _c('p', {
    staticClass: "qqError"
  }, [_vm._v("QQ号格式不正确")]) : _vm._e()])]), _vm._v(" "), _c('footer', [_vm._v("请于2018.01.25前提交你的联系方式，过期后奖品作废。如有其它问题请联系小悠，小悠QQ：3196426910")])])]) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5c86ec22", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c86ec22"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layer/inputqq.vue
// module id = 388
// module chunks = 6